/* IK Sprayers shop-in-shop: the interactive parts of the af-ik-* sections.
   Each block only wires up when its section is on the page, so one file serves the collection
   and product templates. No dependencies; loaded with defer from each section. */
(function () {
  if (window.__afik) return;
  window.__afik = true;
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  // €1.077,00: the store's money format with a dot between thousands and a decimal comma
  window.afikAmount = function (cents) { var p = (cents / 100).toFixed(2).split("."); return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "," + p[1]; };
  var afikAmount = window.afikAmount;
  var data = function (id) { var el = document.getElementById(id); try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } };

  var toastEl, toastT;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement("div"); toastEl.className = "afik afik-toast"; toastEl.setAttribute("role", "status"); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add("is-on"); clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove("is-on"); }, 2800);
  }

  /* hero: never autoplay for reduced motion */
  $$(".afik-hero video").forEach(function (v) { if (reduce) { v.removeAttribute("autoplay"); v.pause(); } });

  /* jobs -> grid */
  var state = { type: "all", job: null };
  function applyGrid() {
    var grid = $("[data-afik-grid]"); if (!grid) return;
    var n = 0, cards = $$("[data-afik-card]", grid);
    cards.forEach(function (c) {
      var okType = state.type === "all" || (" " + c.dataset.type + " ").indexOf(" " + state.type + " ") > -1;
      var okJob = !state.job || (" " + c.dataset.jobs + " ").indexOf(" " + state.job + " ") > -1;
      c.hidden = !(okType && okJob); if (!c.hidden) n++;
    });
    var empty = $("[data-afik-empty]", grid.parentNode); if (empty) empty.hidden = n > 0;
    var count = $("[data-afik-count]"); if (count) count.textContent = count.dataset.tpl.replace("[n]", n).replace("[total]", cards.length);
    $$("[data-afik-type]").forEach(function (b) { b.setAttribute("aria-pressed", b.dataset.afikType === state.type); });
    $$("[data-afik-job]").forEach(function (b) { b.setAttribute("aria-pressed", b.dataset.afikJob === state.job); });
    var aj = $("[data-afik-activejob]");
    if (aj) {
      var src = state.job && $('[data-afik-job="' + state.job + '"] b');
      aj.classList.toggle("is-on", !!state.job);
      $("[data-afik-activejob-name]", aj).textContent = src ? src.textContent : "";
    }
  }
  document.addEventListener("click", function (e) {
    var j = e.target.closest("[data-afik-job]");
    if (j) {
      state.job = state.job === j.dataset.afikJob ? null : j.dataset.afikJob; applyGrid();
      var g = $("[data-afik-grid]"); if (state.job && g) g.closest("section").scrollIntoView({ behavior: reduce ? "auto" : "smooth" });
      return;
    }
    var t = e.target.closest("[data-afik-type]"); if (t) { state.type = t.dataset.afikType; applyGrid(); return; }
    if (e.target.closest("[data-afik-clearjob]")) { state.job = null; applyGrid(); }
  });
  applyGrid();

  /* chemistry selector */
  var chem = data("afik-chem-data");
  var ph = $("[data-afik-ph]");
  if (chem && ph) {
    var special = null;
    var money = function (cents) { return chem.money.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, afikAmount(cents)); };
    // the t filter HTML-escapes ("&" arrives as "&amp;"), and these strings go in with textContent
    var plain = function (s) { var t = document.createElement("textarea"); for (var i = 0; i < 3 && /&[a-z#0-9]+;/i.test(s); i++) { t.innerHTML = s; s = t.value; } return s; };
    var render = function () {
      var v = +ph.value, r;
      if (special) r = chem.rules[special];
      else r = chem.rules[v <= 3 ? "acid_strong" : v <= 6 ? "acid_mild" : v <= 8 ? "neutral" : v <= 11 ? "alk" : "alk_strong"];
      $("[data-afik-phval]").textContent = special ? "–" : v;
      $("[data-afik-phthumb]").style.left = (v / 14 * 100) + "%";
      $("[data-afik-phlab]").textContent = plain(r.label);
      $("[data-afik-line]").textContent = plain(r.line);
      $("[data-afik-seal]").textContent = plain(r.seal);
      $("[data-afik-why]").textContent = plain(r.why);
      $("[data-afik-minis]").innerHTML = r.handles.map(function (h) {
        var p = chem.products[h]; if (!p) return "";
        return '<a class="afik-mini" href="' + p.url + '"><img src="' + p.img + '" alt="" loading="lazy" width="300" height="300"><b>' + p.title + "</b><span>" + money(p.price) + "</span></a>";
      }).join("");
      $$("[data-afik-special]").forEach(function (b) { b.setAttribute("aria-pressed", b.dataset.afikSpecial === special); });
    };
    ph.addEventListener("input", function () { special = null; render(); });
    $$("[data-afik-special]").forEach(function (b) {
      b.addEventListener("click", function () { special = special === b.dataset.afikSpecial ? null : b.dataset.afikSpecial; render(); });
    });
    render();
  }

  /* product: gallery */
  $$("[data-afik-thumbs]").forEach(function (wrap) {
    var main = $("[data-afik-main]");
    wrap.addEventListener("click", function (e) {
      var b = e.target.closest("button"); if (!b || !main) return;
      main.src = b.dataset.src; main.srcset = ""; main.classList.toggle("is-cut", b.dataset.cut === "1");
      $$("button", wrap).forEach(function (x) { x.setAttribute("aria-pressed", x === b); });
    });
  });

  /* product: foam selector */
  var foams = data("afik-foam-data");
  var foamWrap = $("[data-afik-foams]");
  if (foams && foamWrap) {
    var cur = "mid";
    var draw = function (f) {
      var c = $("[data-afik-bubbles]"); if (!c) return;
      var x = c.getContext("2d"), W = c.width; x.clearRect(0, 0, W, W);
      x.save(); x.beginPath(); x.arc(W / 2, W / 2, W / 2, 0, Math.PI * 2); x.clip(); x.fillStyle = "#e3e3df"; x.fillRect(0, 0, W, W);
      var seed = 7, rnd = function () { seed = (seed * 16807) % 2147483647; return seed / 2147483647; };
      for (var i = 0, n = Math.round(380 * f.density); i < n; i++) {
        var r = f.size[0] + rnd() * (f.size[1] - f.size[0]);
        x.beginPath(); x.arc(rnd() * W, rnd() * W, r, 0, Math.PI * 2);
        x.fillStyle = "rgba(255,255,255,.92)"; x.fill(); x.lineWidth = 1; x.strokeStyle = "rgba(140,140,140,.35)"; x.stroke();
      }
      x.restore();
    };
    var renderFoam = function () {
      $$("[data-afik-foam]", foamWrap).forEach(function (b) { b.setAttribute("aria-pressed", b.dataset.afikFoam === cur); });
      var f = foams.filter(function (x) { return x.id === cur; })[0];
      $("[data-afik-foamtext]").textContent = f.text; draw(f);
    };
    foamWrap.addEventListener("click", function (e) { var b = e.target.closest("[data-afik-foam]"); if (b) { cur = b.dataset.afikFoam; renderFoam(); } });
    renderFoam();
  }

  /* product: add-ons, quantity, add to cart */
  var form = $("[data-afik-form]");
  if (form) {
    // The phone buy bar is position:fixed, but the theme's scroll reveal leaves a transform on the
    // section, which turns "fixed" into "stuck to the section". Living under <body> it really sticks.
    var mbar = $(".afik-mbar"); if (mbar && mbar.parentNode !== document.body) document.body.appendChild(mbar);
    var qty = 1, base = +form.dataset.price, money2 = form.dataset.money;
    var fmt = function (c) { return money2.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, afikAmount(c)); };
    var total = function () {
      var t = base * qty;
      $$("[data-afik-addon]").forEach(function (a) { if (a.getAttribute("aria-pressed") === "true") t += +a.dataset.price; });
      $$("[data-afik-total]").forEach(function (el) { el.textContent = fmt(t); });
      $("[data-afik-qty]").textContent = qty;
      var n = $$('[data-afik-addon][aria-pressed="true"]').length, ac = $("[data-afik-addcount]");
      if (ac) ac.textContent = n ? ac.dataset.on.replace("[n]", n) : ac.dataset.off;
    };
    $$("[data-afik-addon]").forEach(function (a) { a.addEventListener("click", function () { a.setAttribute("aria-pressed", a.getAttribute("aria-pressed") !== "true"); total(); }); });
    $("[data-afik-minus]").addEventListener("click", function () { qty = Math.max(1, qty - 1); total(); });
    $("[data-afik-plus]").addEventListener("click", function () { qty = Math.min(20, qty + 1); total(); });
    var add = function () {
      if (form.dataset.available !== "true") { toast(form.dataset.soonMsg); return; }
      var items = [{ id: +form.dataset.variant, quantity: qty }];
      $$('[data-afik-addon][aria-pressed="true"]').forEach(function (a) { if (a.dataset.available === "true") items.push({ id: +a.dataset.variant, quantity: 1 }); });
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : "/") + "cart/add.js", {
        method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: items })
      }).then(function (r) { if (!r.ok) throw r; window.location.href = form.dataset.cartUrl; })
        .catch(function () { toast(form.dataset.errMsg); });
    };
    $$("[data-afik-add]").forEach(function (b) { b.addEventListener("click", add); });
    total();
  }

  /* product: exploded view hotspots */
  $$("[data-afik-explode]").forEach(function (sec) {
    var pick = function (i) {
      $$("[data-afik-feat]", sec).forEach(function (b) { b.setAttribute("aria-pressed", +b.dataset.afikFeat === i); });
    };
    sec.addEventListener("click", function (e) {
      var b = e.target.closest("[data-afik-feat]"); if (!b) return;
      pick(+b.dataset.afikFeat);
      // on phones the feature text sits below the diagram: bring it into view after a hotspot tap
      if (b.classList.contains("afik-hs") && window.innerWidth < 750) {
        var t = $('.afik-feat[aria-pressed="true"]', sec); if (t) t.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "center" });
      }
    });
    pick(0);
  });
})();
